import { Stack, useTheme } from "@mui/material";
import type { FC, Ref } from "react";
import { AmountStepper } from "web_myplann/Shared/Components/AmountStepper";
import { AMOUNT_STEPPER_FIELD_STEP } from "web_myplann/Shared/constants";

type Props = {
	value: number;
	onChange: (value: number) => void;
	inputId?: string;
	focusRef?: Ref<HTMLButtonElement>;
	error?: boolean;
};

export const AmountStepperField: FC<Props> = ({
	value,
	onChange,
	inputId,
	focusRef,
	error = false,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			gap={theme.spacingTokens.md}
			px={theme.spacingTokens.md}
			py={theme.spacingTokens.sm}
			border={theme.colors.border.solid(
				error ? theme.palette.error.main : theme.palette.grey[200],
			)}
			borderRadius={theme.radii.lg}
		>
			<AmountStepper
				size="md"
				value={value}
				onChange={onChange}
				step={AMOUNT_STEPPER_FIELD_STEP}
				inputId={inputId}
				focusRef={focusRef}
			/>
		</Stack>
	);
};
